import { render } from "./DownloadHitList.vue?vue&type=template&id=50d7027f&ts=true"
import script from "./DownloadHitList.vue?vue&type=script&lang=ts"
export * from "./DownloadHitList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__